export default __webpack_public_path__ + "static/media/ornament1.8e74e4fb.png";